import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var GoogleDriveColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m3.333 35.9 1.943 3.319a4.372 4.372 0 0 0 1.66 1.647l6.923-11.894H0a4.51 4.51 0 0 0 .615 2.257L3.333 35.9Z",
    svgColor: "#0066DA"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22 15.004 15.077 3.098a4.531 4.531 0 0 0-1.673 1.659L.614 26.715A4.377 4.377 0 0 0 0 28.959h13.86L22 15.004Z",
    svgColor: "#00AC47"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M37.064 40.89a4.41 4.41 0 0 0 1.673-1.647l.8-1.378 3.86-6.612c.391-.69.598-1.466.603-2.257H30.178l2.951 5.746 3.935 6.148Z",
    svgColor: "#EA4335"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "m22 15.004 6.935-11.906A4.591 4.591 0 0 0 26.66 2.5H17.34c-.792.01-1.57.216-2.263.598L22 15.004Z",
    svgColor: "#00832D"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M30.178 28.996H13.896L6.973 40.89a4.431 4.431 0 0 0 2.262.61H34.84a4.652 4.652 0 0 0 2.262-.61l-6.923-11.894Z",
    svgColor: "#2684FC"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M36.991 15.748 30.597 4.77a4.594 4.594 0 0 0-1.66-1.659L22 15.017l8.14 13.992h13.835a4.582 4.582 0 0 0-.602-2.245L36.99 15.748Z",
    svgColor: "#FFBA00"
  }));
});
GoogleDriveColor.displayName = 'GoogleDriveColor';
GoogleDriveColor.defaultProps = {
  'aria-label': 'GoogleDriveColor'
};
export default GoogleDriveColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/GoogleDriveColor.js
// module id = 2951
// module chunks = 11